import React from 'react';
import MariPhoto from './MariPhoto';
import styles from './mariMessage.module.css';
import { LANDPAGE_MARI_MESSAGE } from '../../landpage.constants';

interface MariMessageTitleProps {
  children: React.ReactNode;
}

export const MariMessageTitle: React.FC<MariMessageTitleProps> = ({ children }) => (
  <h2 className={styles.title}>{children}</h2>
);

interface MariMessageBodyProps {
  paragraphs: readonly string[];
}

export const MariMessageBody: React.FC<MariMessageBodyProps> = ({ paragraphs }) => (
  <div className={styles.body}>
    {paragraphs.map((paragraph) => (
      <p key={paragraph} className={styles.paragraph}>
        {paragraph}
      </p>
    ))}
  </div>
);

interface MariQuoteProps {
  children: React.ReactNode;
}

export const MariQuote: React.FC<MariQuoteProps> = ({ children }) => (
  <p className={styles.quote}>&ldquo;{children}&rdquo;</p>
);

interface MariSignatureProps {
  children: React.ReactNode;
}

export const MariSignature: React.FC<MariSignatureProps> = ({ children }) => (
  <p className={styles.signature}>{children}</p>
);

const MariMessageContent: React.FC = () => {
  const copy = LANDPAGE_MARI_MESSAGE;

  return (
    <div className={styles.content}>
      <MariMessageTitle>{copy.title}</MariMessageTitle>
      <MariMessageBody paragraphs={copy.paragraphsBeforeQuotes} />
      {copy.quotes.map((quote) => (
        <MariQuote key={quote}>{quote}</MariQuote>
      ))}
      <MariMessageBody paragraphs={copy.paragraphsAfterQuotes} />
      <MariSignature>{copy.signature}</MariSignature>
    </div>
  );
};

const MariMessageContainer: React.FC = () => {
  const copy = LANDPAGE_MARI_MESSAGE;

  return (
    <div className={styles.container}>
      <MariPhoto src={copy.imageSrc} alt={copy.imageAlt} />
      <MariMessageContent />
    </div>
  );
};

export default MariMessageContainer;
